goog.provide("shadow.js.shim.module$react_use$lib$useWindowSize");
goog.provide("module$shadow_js_shim_module$react_use$lib$useWindowSize");
shadow.js.shim.module$react_use$lib$useWindowSize = shadow.js.nativeProvides["react-use/lib/useWindowSize"] = shadow$bridge("react-use/lib/useWindowSize");
module$shadow_js_shim_module$react_use$lib$useWindowSize.default = shadow.js.shim.module$react_use$lib$useWindowSize;
